/* eslint-disable @typescript-eslint/naming-convention */
import { isArray } from 'lodash';

const { cos } = Math;

function formulaOne(point: { lat: number; lng: number }, metersNorth: number, metersEast: number) {
  const coefNorth = metersNorth * 0.0000089;
  const coefEast = metersEast * 0.0000089;

  const lat = point.lat + coefNorth;
  const lng = point.lng + coefEast / cos(lat * 0.018);

  return {
    lat,
    lng,
  };
}

function formulaOneArray(point: any[], metersNorth: number, metersEast: number) {
  const coefNorth = metersNorth * 0.0000089;
  const coefEast = metersEast * 0.0000089;

  const lat = point[0] + coefNorth;
  const lng = point[1] + coefEast / cos(lat * 0.018);

  return [lat, lng];
}

export default function addMeter(point: any, metersNorth: any, metersEast: any) {
  if (!isArray(point)) {
    return formulaOne(point, metersNorth, metersEast);
  }
  return formulaOneArray(point, metersNorth, metersEast);
}
